import SideBar from "../../components/sidebar/sidebar";
import { Outlet } from "react-router-dom";

const Home = () => {
  return (
    <div className="flex mt-16">
      <SideBar supplier />
      <main className="w-full overflow-hidden">
        <Outlet />
      </main>
    </div>
  );
};
export default Home;
